import React from "react";
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import _ from '../../../utils/ObjectUtils';
import InputAdornment from "@material-ui/core/InputAdornment/InputAdornment";
import SvgIcon from "@material-ui/core/SvgIcon/SvgIcon";
import {WhiteFormOption} from "../../../style/MUIThemes";
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
    ...WhiteFormOption
});

const TextField =
    ({
         value = "",
         label = "",
         handleFieldChange,
         endAdornment = null,
         isClearable = true,
         formHelperText = null,
         handleFieldBlur = () => { },
         error,
         disabled = false,
         classes = "",
         multiline = false,
         type = 'text',
         width = 6,
         themeName = "default"
     }) => {
        const whiteStyle = useStyles();
        const isWhiteTheme = themeName === 'white';

        return (
            <div className={"col-lg-" + width + ( width < 6 ? " col-md-6 " : " col-md-12 " ) + classes}>
                <FormControl
                    className={classNames({[whiteStyle.root]: isWhiteTheme})}
                    error={!_.isNilOrEmpty(error)}
                    disabled={disabled}
                >
                    <InputLabel
                        className={classNames({[whiteStyle.inputLabel]: isWhiteTheme})}
                        htmlFor="adornment-label"
                    >
                        {label}
                    </InputLabel>
                    <Input
                        id="adornment-label"
                        className={classNames({[whiteStyle.input]: isWhiteTheme})}
                        value={_.isNil(value) ? "" : value.toString()}
                        onChange={e => handleFieldChange(e.target.value)}
                        onBlur={handleFieldBlur}
                        multiline={multiline}
                        type={type}
                        aria-describedby="label-helper-text"
                        autoComplete="false"
                        inputProps={{
                            "aria-label": "label",
                            "autoComplete": "false"
                        }}
                        endAdornment={
                            (isClearable && !disabled) &&
                            <InputAdornment position="end">
                                {endAdornment}
                                <SvgIcon
                                    viewBox="-8 -4 22 22"
                                    className="text-field-clear-icon"
                                    aria-label="Clear text field"
                                    onClick={e => handleFieldChange("")}
                                    cursor="initial"
                                >
                                    <path d="M8.622 9.86c-.124.124-.259.102-.404-.044L4.99 6.589 1.771 9.805c-.146.146-.28.169-.405.045L.133 8.618c-.123-.123-.1-.256.045-.403L3.396 5 .178 1.785C.033 1.64.01 1.505.133 1.38L1.368.15c.123-.122.258-.1.403.046L4.989 3.41 8.22.183c.145-.145.28-.167.403-.045L9.856 1.37c.123.123.1.257-.045.403L6.58 5l3.23 3.227c.146.144.168.279.044.403L8.622 9.86z" />
                                </SvgIcon>
                            </InputAdornment>
                        }
                    />
                    {!_.isNil(formHelperText) &&
                    <FormHelperText id="label-helper-text">{formHelperText}</FormHelperText>
                    }
                    {!_.isNil(error) &&
                    <FormHelperText id="label-helper-text-2">{error}</FormHelperText>
                    }
                </FormControl>
            </div>
        );
    };

TextField.propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.string,
    handleFieldChange: PropTypes.func.isRequired,
    handleFieldBlur: PropTypes.func,
    error: PropTypes.string,
    themeName: PropTypes.string
};

export default TextField;